module.exports = __webpack_public_path__ + "img/gp.53878b37.svg";